
export function getStatus(cSlugname, cType, oStatItem) {

  if (oStatItem.stat_cslugname == cSlugname && oStatItem.stat_ctype == cType)
    return true;

  return false;
}
